import { InspectorControls } from "@wordpress/block-editor";
import { Fragment } from "@wordpress/element";
import { PanelBody, CheckboxControl, TextControl } from "@wordpress/components";

import savef from "./save.jsx";
import Sanitizer from "../sanitizing";
import defaultView, { defaultTitle, defaultPanel } from "../defaultview.js";

export default (props) => {
	const { attributes, setAttributes } = props;
	const { useEffect } = wp.element;
	const { __ } = wp.i18n;
	const sanitizer = Sanitizer();
	props.editor = true;

	useEffect(() => {
		if (attributes.useAverage) {
			let totalRating = 0.0;
			if (attributes.reviews.length > 0) {
				for (var i = 0; i < attributes.reviews.length; i++) {
					totalRating += parseFloat(attributes.reviews[i].rating);
				}
				totalRating = totalRating / attributes.reviews.length;
			}

			const averageRating = sanitizer.sanitizeNumber(totalRating).toFixed(1);
			setAttributes({
				rating: averageRating,
			});
		}
	}, [attributes.reviews, attributes.useAverage]);

	const addRatingBar = () => {
		const tmp = [...attributes.reviews];
		tmp.push({ title: "", rating: 0.0 });
		setAttributes({ reviews: tmp });
	};

	const deleteRatingBar = (index) => {
		console.log(index);
		const tmp = [...attributes.reviews];
		tmp.splice(index, 1);
		setAttributes({ reviews: tmp });
	};

	const updateRatingBarTitle = (event) => {
		const tmp = [...attributes.reviews];
		tmp[event.target.name].title = event.target.value;
		setAttributes({ reviews: tmp });
	};

	const updateRatingBarRating = (event) => {
		const newValue = sanitizer.sanitizeNumber(event.target.value);
		const tmp = [...attributes.reviews];
		tmp[event.target.name].rating =
			newValue >= attributes.maxRating ? attributes.maxRating : newValue;
		setAttributes({ reviews: tmp });
	};

	const useAverageRating = (value) => {
		setAttributes({ useAverage: value });
	};

	function updateMax(event) {
		const previousMax = attributes.maxRating;
		const newMax = event.target.value;
		setAttributes({ maxRating: sanitizer.sanitizeNumber(newMax) });
		const tmp = [...attributes.reviews];
		tmp.forEach(
			(r) => (r.rating = (newMax * (r.rating / previousMax)).toFixed(1))
		);
		setAttributes({ reviews: tmp });
	}
	function updateRating(event) {
		setAttributes({
			rating: sanitizer.sanitizeNumber(event.target.value),
		});
	}
	function updateRatingText(value) {
		setAttributes({ ratingText: value });
	}

	const RatingBars = () => {
		return attributes.reviews.map((item, index) => (
			<div>
				<button
					onClick={() => {
						deleteRatingBar(index);
					}}
				>
					x
				</button>
				<input
					type="text"
					name={index}
					placeholder={__("Rating Title", "sptcrb")}
					defaultValue={item.title}
					value={item.title}
					onChange={updateRatingBarTitle}
				/>
				<input
					type="number"
					min="0"
					max={attributes.maxRating}
					name={index}
					defaultValue={item.rating}
					value={item.rating}
					onChange={updateRatingBarRating}
				/>
			</div>
		));
	};

	return (
		<Fragment>
			<InspectorControls>
				{defaultPanel()}
				<PanelBody title="Overall Rating" initialOpen={false}>
					<label className="components-base-control__label sptcrb-control-label">
						Max Rating
					</label>
					<div class="sptcrb__rating__block__ratingbar_rating__column">
						<input
							type="number"
							min="1"
							max="100"
							defaultValue={attributes.maxRating}
							onChange={updateMax}
						/>
					</div>
					<label className="components-base-control__label sptcrb-control-label">
						Overall Rating
					</label>
					<div class="sptcrb__rating__block__ratingbar_rating__column">
						<input
							id="sptcrb__rating-input"
							type="number"
							min="0"
							max={attributes.maxRating}
							defaultValue={attributes.rating}
							value={attributes.rating}
							onChange={updateRating}
							disabled={attributes.useAverage ? "disabled" : ""}
						/>
					</div>
					<div class="sptcrb__rating__block__checkbox">
						<CheckboxControl
							label={__("Use Rating Bar Average as Overall Rating", "sptcrb")}
							onChange={useAverageRating}
							checked={attributes.useAverage}
						/>
					</div>
				</PanelBody>
				<PanelBody title="Rating Bars" initialOpen={true}>
					<div class="sptcrb__rating__block__ratingbar_button">
						<button onClick={addRatingBar}>Add Rating Bar</button>
					</div>
					<div class="sptcrb__rating__block__review">{RatingBars()}</div>
				</PanelBody>
				<PanelBody title="Text Settings" initialOpen={false}>
					<TextControl
						id="sptcrb__rating-text"
						label="Title"
						defaultValue={attributes.ratingText}
						onChange={updateRatingText}
						placeholder={__("Overall Rating", "sptcrb")}
					/>
				</PanelBody>
				<PanelBody title={defaultTitle} initialOpen={true}>
					{defaultView()}
				</PanelBody>
			</InspectorControls>
			{savef(props)}
		</Fragment>
	);
};
